module.exports = __webpack_public_path__ + "img/SES_160255000.0ea65761.jpg";